(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-hub-video]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const id = button.dataset.hubVideo;
        if (!/^[\w-]{11}$/.test(id || '')) return;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        iframe.title = button.dataset.videoTitle;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.tabIndex = 0;
        button.replaceWith(iframe);
        iframe.focus();
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
